import React, { useState, useEffect } from 'react';
import Modal from '../Modal/Modal';
import styles from './RewardedTasksModal.module.css';
import { useMetadata } from '../../context/MetadataContext';

const RewardedTasksModal = ({ isOpen, onClose, offerwallUrl }) => {
  const { getText } = useMetadata();
  const [isLoading, setIsLoading] = useState(true);

  // Reset loading state when modal opens
  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
    }
  }, [isOpen]);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={getText('tokens.rewarded_tasks_modal_title') || 'Rewarded Tasks'}
      className={styles.rewardedTasksModal}
      closeOnBackdropClick={false}
    >
      <div className={styles.modalContent}>
        <div className={styles.instructions}>
          <p>{getText('tokens.rewarded_tasks_modal_instructions') || 'Complete tasks below to earn tokens. Rewards may take some time to appear in your account.'}</p>
        </div>

        {isLoading && (
          <div className={styles.loadingOverlay}>
            <div className={styles.loadingSpinner}></div>
            <p>Loading tasks...</p>
          </div>
        )}

        <div className={styles.iframeContainer}>
          <iframe
            src={offerwallUrl}
            className={styles.iframe}
            title="Rewarded Tasks"
            onLoad={handleIframeLoad}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
          />
        </div>

        <div className={styles.footer}>
          <button
            onClick={onClose}
            className={styles.closeButton}
          >
            {getText('common.close') || 'Close'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RewardedTasksModal;
